import * as React from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText, PrismicLink } from '@prismicio/react'
import { isFilled } from '@prismicio/helpers'
import { FaDownload, FaExternalLinkAlt } from 'react-icons/fa'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6'

export const Hero = ({ slice }) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false)
  const [activeDropdown, setActiveDropdown] = React.useState(null)

  const handleButtonClick = () => {
    setDropdownOpen((prev) => !prev)
  }

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index)
  }

  return (
    <section className="WellbeingHero Hero">
      <div className="Container Hero__flex">
        <div
          className={`Hero_image_container ${
            slice.primary.image_side ? 'image_right' : 'image_left'
          }`}
        >
          {isFilled.image(slice.primary.background_image) && (
            <GatsbyImage
              className={
                slice.primary.image_side
                  ? 'Hero_background_image_right'
                  : 'Hero_background_image_left'
              }
              image={slice.primary.background_image.gatsbyImageData}
              alt={slice.primary.background_image.alt || ''}
            />
          )}
          {isFilled.image(slice.primary.image) && (
            <GatsbyImage
              className="Hero_main_image"
              image={slice.primary.image.gatsbyImageData}
              alt={slice.primary.image.alt || ''}
            />
          )}
        </div>
        <div className="header_and_text">
          {isFilled.richText(slice.primary.header.richText) && (
            <PrismicRichText field={slice.primary.header.richText} />
          )}
          {isFilled.richText(slice.primary.text.richText) && (
            <PrismicRichText field={slice.primary.text.richText} />
          )}

          {slice.primary.button_label && slice.primary.button_url?.url && (
            <div className="hero_button">
              <PrismicLink
                href={slice.primary.button_url.url}
                className="light-blue-btn"
              >
                {slice.primary.button_label}
              </PrismicLink>
            </div>
          )}

          {slice.items.length > 0 && (
            <div className="pdf-links">
              {slice.items.map((item, index) => (
                <div key={index} className="dropdown-container">
                  <button
                    className="light-blue-btn dropdown-title"
                    onClick={() => toggleDropdown(index)}
                  >
                    {item.pdf_button_label}
                    {activeDropdown === index ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </button>

                  {activeDropdown === index && (
                    <div className="dropdown-options">
                      <PrismicLink
                        href={item.pdf_button_browser_link?.url}
                        className="dropdown-option"
                      >
                        <FaExternalLinkAlt color="#0E6BA8" />
                        View in Browser
                      </PrismicLink>
                      <PrismicLink
                        href={item.pdf_button_download?.url}
                        className="dropdown-option"
                      >
                        <FaDownload color="#0E6BA8" />
                        Download PDF
                      </PrismicLink>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export const query = graphql`
  fragment UpdatedPageDataBodyHero on PrismicUpdatedPageDataBodyHero {
    id
    primary {
      image_side
      header {
        richText
      }
      text {
        richText
      }
      image {
        gatsbyImageData
        url
        alt
      }
      background_image {
        gatsbyImageData
        url
        alt
      }
      button_label
      button_url {
        url
      }
    }
    items {
      pdf_button_label
      pdf_button_browser_link {
        url
      }
      pdf_button_download {
        url
      }
    }
  }
`
